import React from 'react';
import { connect } from 'react-redux';
import { LinearProgress, Typography } from '@mui/material';
import { Row } from '../util/Page';
import EquipTypeLoader from '../loaders/EquipTypeLoader';
import BuildingPoints from './BuildingPoints';

const IngestPointStatus = ({ buildings, loaded }) => {
  if (!loaded) {
    return (
      <Row>
        <LinearProgress className="loading" color="secondary" />
      </Row>
    );
  }

  if (!buildings.length) {
    return (
      <Row>
        <Typography variant="h5">No buildings with ingest data yet</Typography>
      </Row>
    );
  }

  return (
    <>
      <EquipTypeLoader />
      {buildings.map((bid) => (
        <BuildingPoints key={bid} buildingId={bid} />
      ))}
    </>
  );
};

export default connect(
  ({
    entities: {
      ingestStats: { loaded },
    },
  }) => ({ loaded })
)(IngestPointStatus);
